import React from "react";
import { Helmet } from "react-helmet-async";
import { SecondaryButton } from "../components/Common/SecondaryButton";
import { useQueryParams } from "../hooks/useQueryParams";

/**
 * This page is opened as a popup at a small fixed size, so we don't need the menu, header etc. Just a basic page
 */
export const KycCompletedPage = () => {
    const queryParams = useQueryParams();
    const status = queryParams.get("status") ?? "success";

    return (
        <div>
            <Helmet defer={false}>
                <title>KYC Complete</title>
            </Helmet>
            <div className="space-y-4 p-4">
                <h2>Xola Stripe KYC</h2>
                {status === "success" ? (
                    <p>
                        Thank you for updating your KYC with Stripe. Your KYC information may take a few minutes to
                        update within Xola.
                    </p>
                ) : (
                    <p>There was an error updating your KYC info. Please open a new KYC window and try again.</p>
                )}
                <p>
                    <SecondaryButton size="small" onClick={handleClick}>
                        Close Window
                    </SecondaryButton>
                </p>
            </div>
        </div>
    );
};

const handleClick = () => {
    window.close();
};
